import { Component, OnInit, Input } from '@angular/core'

@Component({
  selector: 'dmmp-website-course-detailed-tabs',
  templateUrl: './website-course-detailed-tabs.component.html'
})
export class WebsiteCourseDetailedTabsComponent implements OnInit {

  @Input() identifier
  @Input() module
  @Input() data
  @Input() contentItemListCount = 4

  constructor() { }

  ngOnInit(): void {
  }

  showMore() {
    this.contentItemListCount = this.data?.chapters?.length
  }

}
